var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirecto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconos-app-codere-Expand_icon-en-directo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 19.008,
    viewBox: "0 0 36 19.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M55.487,52.184,53.41,46.59H51.48l3.21,8h1.545l3.21-8H57.563Z",
    transform: "translate(-36.011 -41.087)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1.748,
    height: 7.942,
    transform: "translate(12.379 5.503)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M84.026,51.31H87.77V49.755H84.026V48.144h4.254V46.59H82.29v7.945h6.047V52.98H84.026Z",
    transform: "translate(-57.54 -41.087)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M19.188,46.59H17.44v7.945h5.707v-1.59H19.188Z",
    transform: "translate(-12.237 -41.087)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M32.286,28.32H3.714A3.726,3.726,0,0,0,0,32.034v11.58a3.726,3.726,0,0,0,3.714,3.714H32.286A3.726,3.726,0,0,0,36,43.614V32.034A3.726,3.726,0,0,0,32.286,28.32ZM33.6,43.62a1.332,1.332,0,0,1-1.314,1.314H3.714A1.332,1.332,0,0,1,2.4,43.614V32.034A1.332,1.332,0,0,1,3.714,30.72H32.286A1.332,1.332,0,0,1,33.6,32.034Z",
    transform: "translate(0 -28.32)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirecto);
export default __webpack_public_path__ + "static/media/directo.e24ddc643046a1d42153751794b85335.svg";
export { ForwardRef as ReactComponent };